import { Provider } from "react-redux"
import type { ReactNode } from "react"
import store from "./store"

type Props = {
  readonly children: ReactNode
}

export default function StoreProvider({ children }: Props) {
  return <Provider store={store}>{children}</Provider>
}
